export default "__VITE_ASSET__D9qQwo3b__"